import { CustomTipType } from '@ready/dashboardv2api.contracts';

/**
 * Default tip percentage values for regular tips
 */
export const DEFAULT_TIP_PERCENTAGES = [15, 18, 20] as const;

/**
 * Default tip percentage values for service charges
 */
export const DEFAULT_SERVICE_CHARGE_TIP_PERCENTAGES = [0, 2, 5] as const;

/**
 * Default placeholder values for tip inputs
 */
export const DEFAULT_TIP_PLACEHOLDERS = ['15', '18', '20'];

/**
 * Default placeholder values for service charge tip inputs
 */
export const DEFAULT_SERVICE_CHARGE_TIP_PLACEHOLDERS = ['0', '2', '5'];

/**
 * Custom tip type options for dropdowns
 */
export const CUSTOM_TIP_TYPE_OPTIONS = [
  { label: 'Percentage', value: CustomTipType.Percentage },
  { label: 'Dollar Amount', value: CustomTipType.DollarAmount },
];

/**
 * Before/After calculation options for tip calculation dropdowns
 */
export const TIP_CALCULATION_OPTIONS = [
  { label: 'Before', value: true },
  { label: 'After', value: false },
];

/**
 * Maximum length for tip custom messages
 */
export const TIP_MESSAGE_MAX_LENGTH = 200;

/**
 * Default number of tip value inputs
 */
export const DEFAULT_TIP_COUNT = 3;

/**
 * Common tip configuration defaults
 */
export const TIP_CONFIGURATION_DEFAULTS = {
  allowTips: true,
  preNonReadyPaymentsTip: true,
  preDiscountTip: true,
  preItemDiscountTip: true,
  preTaxTip: false,
  bottomText: '',
  showBottomText: false,
  defaultTips: DEFAULT_TIP_PERCENTAGES,
  defaultTipsForServiceCharges: DEFAULT_SERVICE_CHARGE_TIP_PERCENTAGES,
  defaultCustomTipType: CustomTipType.Percentage,
} as const;
